<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
  >
    <template v-slot:activator="{ on: dialog }">
      <v-row align="center" no-gutters>
        <v-btn text small v-on="{ ...dialog }" class="px-0">
          <span style="text-transform: capitalize;">{{ getRecipeName }}</span>
        </v-btn>
      </v-row>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <RecipeViewer
          ref="viewer"
          :id="id"
          :quantity="quantity"
          v-show="!loading"
        ></RecipeViewer>
        <v-row align="center" class="my-3" no-gutters v-show="loading">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { RecipeViewer } from "../views";
import { mapGetters } from "vuex";
export default {
  name: "RecipeDialogViewer",
  components: {
    RecipeViewer
  },
  props: {
    id: {
      required: true
    },
    quantity: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapGetters(["getRecipes"]),
    getRecipeName() {
      return this.getRecipes.find(x => x.id === this.id).nom;
    }
  },
  data() {
    return {
      dialog: false,
      loading: true,
      isLoaded: false
    };
  },
  watch: {
    dialog(v) {
      if (v === true && this.isLoaded === false) {
        setTimeout(async () => {
          try {
            this.loading = true;
            await this.$refs.viewer.getData();
            this.isLoaded = true;
          } finally {
            this.loading = false;
          }
        }, 300);
      }
    }
  }
};
</script>

<style></style>
